/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PspDataR = t.interface({
  codiceAbi: t.string,

  defaultPsp: t.boolean,

  fee: t.Integer,

  id: t.Integer,

  idPsp: t.string,

  onboard: t.boolean,

  ragioneSociale: t.string
});

// optional attributes
const PspDataO = t.partial({
  privacyUrl: t.string
});

export const PspData = t.intersection([PspDataR, PspDataO], "PspData");

export type PspData = t.TypeOf<typeof PspData>;
